export class CreateOutsideSurveyDto {
  surveyId: string;
  buildingId: string;
  outsideEngineerId: string;
  isPrefill: boolean;

  constructor(data: {
    surveyId: string;
    buildingId: string;
    outsideEngineerId: string;
    isPrefill: boolean;
  }) {
    this.surveyId = data.surveyId;
    this.buildingId = data.buildingId;
    this.outsideEngineerId = data.outsideEngineerId;
    this.isPrefill = data.isPrefill;
  }
}
